"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const ml_spectra_processing_1 = require("ml-spectra-processing");
const react_2 = require("react");
const bs_1 = require("react-icons/bs");
const io5_1 = require("react-icons/io5");
const get1DDataXY_1 = require("../../data/data1d/Spectrum1D/get1DDataXY");
const BrushTracker_1 = require("../EventsTrackers/BrushTracker");
const MouseTracker_1 = require("../EventsTrackers/MouseTracker");
const ChartContext_1 = require("../context/ChartContext");
const ScaleContext_1 = require("../context/ScaleContext");
const useActiveSpectrum_1 = require("../hooks/useActiveSpectrum");
const useFormatNumberByNucleus_1 = require("../hooks/useFormatNumberByNucleus");
const useSpectrum_1 = __importDefault(require("../hooks/useSpectrum"));
const styles = (0, react_1.css) `
  display: flex;
  align-items: center;
  pointer-events: bounding-box;
  user-select: none;
  background-color: #f7f7f7;
  height: 30px;
  padding: 6px;
  color: #8d0018;
  position: absolute;
  width: 100%;
  bottom: 0;
  container-type: inline-size;

  @container (max-width:600px) {
    .small-width-none {
      display: none !important;
    }
  }

  .flex-row {
    display: flex;
    align-items: center;
  }

  div {
    margin: 0 10px;
    display: inline-block;

    .label {
      font-size: 12px;
      color: #4d4d4d;
      font-weight: bold;
    }

    .value {
      font-weight: bold;
      font-size: 14px;
      display: inline-block;
    }

    .unit {
      font-weight: bold;
      font-size: 10px;
    }

    .x-value {
      min-width: 50px;
    }

    .y-value {
      min-width: 80px;
    }
  }

  .separator {
    border-left: 2px solid gray;
    margin: 0 20px;
    width: 1px;
    height: 100%;
  }
`;
function FooterBannerInner({ margin, width, height, activeSpectrum, spectrum, activeTab, }) {
    const position = (0, MouseTracker_1.useMouseTracker)();
    const { startX, endX, step, mouseButton } = (0, BrushTracker_1.useBrushTracker)();
    const { scaleX } = (0, ScaleContext_1.useScaleChecked)();
    const format = (0, useFormatNumberByNucleus_1.useFormatNumberByNucleus)(activeTab);
    if (!position ||
        position.y < margin.top ||
        position.x < margin.left ||
        position.x > width - margin.right ||
        position.y > height - margin.bottom) {
        return (0, jsx_runtime_1.jsx)("div", { css: styles });
    }
    function getXIndex(xPosition) {
        if (spectrum) {
            const data = (0, get1DDataXY_1.get1DDataXY)(spectrum);
            return (0, ml_spectra_processing_1.xFindClosestIndex)(data.x, scaleX().invert(xPosition));
        }
        return 0;
    }
    function getYValue(xPosition) {
        if (spectrum) {
            const data = (0, get1DDataXY_1.get1DDataXY)(spectrum);
            const xIndex = getXIndex(xPosition);
            return data.y[xIndex];
        }
        return 1;
    }
    const isBrushing = step === 'brushing' && mouseButton === 'main';
    return ((0, jsx_runtime_1.jsxs)("div", { css: styles, children: [(0, jsx_runtime_1.jsx)(bs_1.BsCursor, {}), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: " \uD835\uDEC5: " }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: format(scaleX().invert(position.x)) }), (0, jsx_runtime_1.jsx)("span", { className: "unit", children: "ppm" }), activeSpectrum && spectrum?.info?.originFrequency && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)("span", { className: "value", children: ["\u00A0(", format(scaleX().invert(position.x) * spectrum?.info?.originFrequency, 'hz')] }), (0, jsx_runtime_1.jsx)("span", { className: "unit", children: "Hz" }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: ") " }), (0, jsx_runtime_1.jsxs)("span", { className: "small-width-none", children: [(0, jsx_runtime_1.jsx)("span", { children: "," }), (0, jsx_runtime_1.jsx)("span", { className: "label", children: " Index: " }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: getXIndex(position.x) })] })] }))] }), isBrushing && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row small-width-none", children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: " \u0394ppm: " }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: (scaleX().invert(startX) - scaleX().invert(endX)).toPrecision(6) })] })), activeSpectrum && ((0, jsx_runtime_1.jsxs)("div", { className: " flex-row small-width-none", children: [spectrum?.info?.originFrequency && isBrushing && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: " \u0394Hz: " }), (0, jsx_runtime_1.jsx)("span", { className: "value", children: ((scaleX().invert(startX) - scaleX().invert(endX)) *
                                    spectrum?.info?.originFrequency).toPrecision(5) })] })), isBrushing && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: " ratio :" }), (0, jsx_runtime_1.jsxs)("span", { className: "value", children: [((getYValue(startX) / (getYValue(endX) || Number.MIN_VALUE)) *
                                        100).toFixed(2), "%"] })] }))] })), activeSpectrum && ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row small-width-none", children: [(0, jsx_runtime_1.jsx)("div", { className: "separator" }), (0, jsx_runtime_1.jsx)(io5_1.IoPulseSharp, {}), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("span", { className: "label", children: "Intensity: " }), (0, jsx_runtime_1.jsx)("span", { className: "value y-value", children: format(getYValue(position.x)) })] })] }))] }));
}
const MemoizedFooterBanner = (0, react_2.memo)(FooterBannerInner);
function FooterBanner() {
    const { margin, width, height, view: { spectra: { activeTab }, }, } = (0, ChartContext_1.useChartData)();
    const activeSpectrum = (0, useActiveSpectrum_1.useActiveSpectrum)();
    const spectrum = (0, useSpectrum_1.default)(null);
    return ((0, jsx_runtime_1.jsx)(MemoizedFooterBanner, { margin, width, height, activeSpectrum, spectrum, activeTab }));
}
exports.default = FooterBanner;
